<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 344px)">
            <div class="mainBody">
                <div class="searchBox" v-if="list_model ==1">
                    <div class="searchGroup">
                        <label>灌浆类型：</label>
                        <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                </div>
                <div class="dataBox" v-if="list_model ==1">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="hole_order" label="孔序" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom" width="100"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <el-button  size="mini" plain type="primary" @click="info(scope.$index, scope.row)">查看</el-button>
                                <el-button  size="mini" plain type="primary" @click="downAnnex(scope.$index, scope.row)" v-if="scope.row.annex_count>0">下载附件</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox" v-if="list_model ==1">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2">
                    <h3>
                        孔号：{{work_hole.hole_code}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                </div>
                
                <div class="dataBox" v-if="list_model ==2">
                    <el-table :data="tableData1" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号" width="220"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" width="120"></el-table-column>
                        <el-table-column prop="report_count" label="报告数量" width="120"></el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button  size="mini" plain type="primary" @click="infoAll(scope.row)">查看</el-button>
                                <el-button  size="mini" plain type="primary" @click="infoVerifyCheck(scope.row)" v-if="scope.row.has_verify_check>0">查看监测对比分析</el-button>
                                <el-button  size="mini" plain type="primary" @click="createJiaoYan(scope.row)" v-else>生成监测对比分析</el-button>
                                <el-button  size="mini" plain type="primary" @click="infoVerifyDiff(scope.row)" v-if="scope.row.has_verify_diff>0">查看差异对比分析</el-button>
                                <el-button  size="mini" plain type="primary" @click="createChaYi(scope.row)" v-else>生成差异对比分析</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <Info
                    :report_type="report_type"
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="查看检验孔作业报告"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <AnnexList
                    width="600px"
                    :data_id="model_id"
                    :isshow="annexshow"
                    @on-close="closeAnnexDialog">
                </AnnexList>
                <VerifyCheckInfo
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="检验孔监测数据验证分析详情"
                    :isshow="verify_check_show"
                    report_type="12"
                    @on-close="closeVerifyCheckDialog"
                    @on-save-ok="closeVerifyCheckDialog">
                </VerifyCheckInfo>
                <VerifyDiffInfo
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    title="检验孔抽检数据验证分析详情"
                    :isshow="verify_diff_show"
                    report_type="14"
                    @on-close="closeVerifyDiffDialog"
                    @on-save-ok="closeVerifyDiffDialog">
                </VerifyDiffInfo>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { holeReportListCheck } from '@/api/workreport'
import { createVerifyFromFile } from '@/api/statistic'
import Info from "./info"
import VerifyCheckInfo from "../verify/checkinfo.vue"
import VerifySpotInfo from "../verify/spotinfo.vue"
import VerifyDiffInfo from "../verify/diffinfo.vue"
import AnnexList from "./annexlist"

export default {
    name: 'checkholeworkreportList',
    mixins: [listutil],
    components: {Info, Btns, LabBtns, AnnexList, VerifyCheckInfo, VerifySpotInfo, VerifyDiffInfo},
    data() {
        return {
            m_name: '灌浆孔-作业报告',
            menu_id: 5860,
            list_url: "/api/admin/workholecheck/list",
            search_Obj: {
                f_hole_code: '',
                report_type: 11
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            list_model: 1,
            report_type: 11,
            hole_id: 0,
            segment_no: '',
            tableData1: [],
            work_hole: {},
            annexshow: false,
            verify_check_show: false,
            verify_spot_show: false,
            verify_diff_show: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            this.list_model = 2
            holeReportListCheck(row.id, this.report_type).then(res=>{
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.work_hole = res.data.work_hole
                }
            })
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
        },
        infoAll(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        downAnnex(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
        infoVerifyCheck(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_check_show = true
        },
        infoVerifySpot(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_spot_show = true
        },
        infoVerifyDiff(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.verify_diff_show = true
        },
        closeVerifyCheckDialog(){
            this.verify_check_show = false
        },
        closeVerifySpotDialog(){
            this.verify_spot_show = false
        },
        closeVerifyDiffDialog(){
            this.verify_diff_show = false
        },
        createJiaoYan(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            createVerifyFromFile(12, this.hole_id, this.segment_no).then(res=>{
                if(res.code ==1){
                    this.$msgs("生成成功")
                    setTimeout(() => {
                        let hole = {
                            "id": this.hole_id
                        }
                        this.info(1, hole);
                    }, 1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        createChaYi(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            createVerifyFromFile(14, this.hole_id, this.segment_no).then(res=>{
                if(res.code ==1){
                    this.$msgs("生成成功")
                    setTimeout(() => {
                        let hole = {
                            "id": this.hole_id
                        }
                        this.info(1, hole);
                    }, 1000);
                }else{
                    this.$msg(res.msg)
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
</style>